import Create from "./Create";
import Edit from "./Edit";
import List from "./List";
import { MonitorIcon } from "../icons";

export default {
  options: {
    group: "config",
    accessible: ({ user }) =>
      user.role === "admin" && user.permissions.indexOf("monitor/list") !== -1,
  },
  icon: MonitorIcon,
  list: List,
  edit: Edit,
  create: Create,
};
